import { IconLoader } from '@ui/src';
import { SheetProps } from './types';
import Category from '../partial/reports/category';
import TotalSum from '../partial/reports/total-sum';
import ReportHeader from '../partial/reports/header';
import formatReportBalance from '../../hoc/helpers/format-report-balance';

import ROUTES from '../../routes';

import cn from './profit-loss.module.css';

const Sheet = ({
  items,
  itemsVisible,
  totalExpenses,
  isLoading,
  profitLoss,
  search,
}: SheetProps) => {
  let content = (
    <div className={cn.reportLoader}>
      <IconLoader />
    </div>
  );

  if (!isLoading) {
    const income = items?.filter((item) => item?.name?.includes('Income'));
    const expense = items?.filter((item) => item?.name?.includes('expense'));

    content = (
      <div className={cn.profitLossList}>
        {income?.map((item) => (
          <Category
            itemsVisible={itemsVisible}
            category={item}
            key={item.id}
            search={search}
            fromPath={ROUTES.REPORTS_PROFIT_lOSS_SHEET}
            type="profit-loss"
            isIncome
          />
        ))}
        {expense?.map((item) => (
          <Category
            itemsVisible={itemsVisible}
            category={item}
            fromPath={ROUTES.REPORTS_PROFIT_lOSS_SHEET}
            key={item.id}
            search={search}
            type="profit-loss"
          />
        ))}
        <TotalSum
          title="Total Expense"
          total={
            totalExpenses || {
              debitIn: 0,
              debitOut: 0,
              debitTo: 0,
              creditIn: 0,
              creditOut: 0,
              creditTo: 0,
            }
          }
        />
      </div>
    );
  }

  return (
    <div className={cn.profitLossSheetContent}>
      <ReportHeader />
      {content}
      <div
        className={`${cn.checksum} ${
          profitLoss?.creditOut && profitLoss?.creditOut < 0
            ? cn.checksumRed
            : ''
        }`}
      >
        <div className={`${cn.checksumName} ${cn.checksumValue}`}>
          <span>Profit (Loss)</span>
        </div>
        <div className={cn.checksumValue} />
        <div className={cn.checksumValue} />
        <div className={cn.checksumValue}>
          <span>{formatReportBalance(profitLoss?.creditIn || 0)}</span>
        </div>
        <div className={cn.checksumValue} />
        <div className={cn.checksumValue}>
          <span>{formatReportBalance(profitLoss?.creditTo || 0)}</span>
        </div>
        <div className={cn.checksumValue} />
        <div className={cn.checksumValue}>
          <span>{formatReportBalance(profitLoss?.creditOut || 0)}</span>
        </div>
      </div>
    </div>
  );
};

export default Sheet;
